export default "__VITE_ASSET__DIHIjMTk__"